(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["carousel"] && !Shopify.designMode) return;
  try {
    class CarouselBlock extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;

      this.loop = this.dataset.loop === 'true';
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      this.dotsEl = this.querySelector('[data-dots]');
      this.isDragging = false;
      this.isTouching = false;
      this.realCount = 0;
      this.hasClones = false;

      this.markWrapper();
      if (this.classList.contains('carousel--bleed-mobile')) this.initBleed();

      this.handlePrev = () => this.go(-1);
      this.handleNext = () => this.go(1);
      this.prevBtn?.addEventListener('click', this.handlePrev);
      this.nextBtn?.addEventListener('click', this.handleNext);

      this.onScroll = this.debounce(() => {
        this.normalize();
        this.sync();
      }, 90);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      this.onResize = this.debounce(() => {
        this.realign();
        this.sync();
      }, 150);
      window.addEventListener('resize', this.onResize);

      this.initTouchGuard();
      if (this.dataset.drag === 'true') this.initDrag();
      if (this.dataset.autoplay === 'true') this.initAutoplay();

      this.observer = new MutationObserver(() => this.refresh());
      this.refresh();
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      if (this.onBleedResize) window.removeEventListener('resize', this.onBleedResize);
      this.prevBtn?.removeEventListener('click', this.handlePrev);
      this.nextBtn?.removeEventListener('click', this.handleNext);
      this.stopAutoplay();
      this.visibilityObserver?.disconnect();
      if (this.handleVisibility) document.removeEventListener('visibilitychange', this.handleVisibility);
      this.observer?.disconnect();
    }

    // The theme may wrap the block in a container that becomes the flex item.
    // A width set on the custom element alone would not constrain that wrapper,
    // and a shrink-to-fit wrapper collapses the whole carousel to zero.
    markWrapper() {
      const wrapper = this.parentElement;
      if (!wrapper || wrapper.children.length !== 1) return;
      wrapper.classList.add('carousel-wrapper');
    }

    // Bleed past the inline-end edge on mobile without switching the section
    // to full width. Offsets are measured rather than assumed: the block may
    // sit inside nested padded containers whose inset is not knowable in CSS.
    initBleed() {
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.updateBleed();
      // Re-measure once after first layout: theme wrappers and web fonts can
      // shift the horizontal insets after connectedCallback runs.
      requestAnimationFrame(() => this.updateBleed());

      this.onBleedResize = this.debounce(() => this.updateBleed(), 150);
      window.addEventListener('resize', this.onBleedResize);
    }

    updateBleed() {
      this.style.removeProperty('--carousel-bleed-width');
      this.style.removeProperty('--carousel-bleed-end');

      if (!this.mobileQuery.matches) return;

      // clientWidth, not innerWidth: it excludes any classic scrollbar gutter.
      const viewport = document.documentElement.clientWidth;
      const rect = this.getBoundingClientRect();
      const rtl = getComputedStyle(this).direction === 'rtl';
      const start = rtl ? viewport - rect.right : rect.left;
      // Derived from the same numbers so the flow width is unchanged to the
      // subpixel: any residual here becomes page-wide horizontal scroll.
      const end = viewport - rect.width - start;

      if (start < 0 || end < 0) return;

      this.style.setProperty('--carousel-bleed-width', `${viewport - start}px`);
      this.style.setProperty('--carousel-bleed-end', `${end}px`);

      if (this.hasClones) requestAnimationFrame(() => this.realign());
    }

    get slides() {
      return Array.from(this.track.children);
    }

    get maxScroll() {
      return this.track.scrollWidth - this.track.clientWidth;
    }

    // Cards snap to start, so the scroll position of a card is its offset.
    // offsetParent is the viewport and the track has no inline padding.
    get current() {
      const scroll = this.track.scrollLeft;
      let best = 0;
      let min = Infinity;
      this.slides.forEach((slide, i) => {
        const distance = Math.abs(slide.offsetLeft - scroll);
        if (distance < min) {
          min = distance;
          best = i;
        }
      });
      return best;
    }

    refresh() {
      this.buildLoop();
      this.buildDots();
      this.sync();
    }

    // Duplicate the full set before and after the originals, then park the
    // viewport on the middle set. Scrolling past either end lands on a clone
    // that is pixel-identical to the real card, so the position can be
    // swapped silently once the scroll settles.
    buildLoop() {
      this.observer.disconnect();

      this.track.querySelectorAll('[data-carousel-clone]').forEach((node) => node.remove());

      const originals = this.slides;
      this.realCount = originals.length;
      this.hasClones = false;

      if (this.loop && this.realCount > 1) {
        const lead = document.createDocumentFragment();
        const trail = document.createDocumentFragment();

        originals.forEach((slide) => {
          lead.appendChild(this.cloneSlide(slide));
          trail.appendChild(this.cloneSlide(slide));
        });

        this.track.insertBefore(lead, originals[0]);
        this.track.appendChild(trail);
        this.hasClones = true;

        requestAnimationFrame(() => this.jumpToSlide(this.realCount));
      }

      this.observer.observe(this.track, { childList: true });
    }

    cloneSlide(slide) {
      const clone = slide.cloneNode(true);
      clone.setAttribute('data-carousel-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      clone.inert = true;
      clone.removeAttribute('id');
      clone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
      return clone;
    }

    // A silent scrollLeft jump while a finger is still on the screen fights
    // the native touch scroll, so the swap waits for the gesture to end.
    initTouchGuard() {
      const start = () => {
        this.isTouching = true;
      };
      const end = () => {
        this.isTouching = false;
        this.onScroll();
      };
      this.track.addEventListener('touchstart', start, { passive: true });
      this.track.addEventListener('touchend', end, { passive: true });
      this.track.addEventListener('touchcancel', end, { passive: true });
    }

    normalize() {
      if (!this.hasClones || this.isDragging || this.isTouching) return;

      const index = this.current;
      if (index >= this.realCount && index < this.realCount * 2) return;

      const setWidth = this.slides[this.realCount].offsetLeft - this.slides[0].offsetLeft;
      this.jumpTo(this.track.scrollLeft + (index < this.realCount ? setWidth : -setWidth));
    }

    // The card size changes at the breakpoint, so the current card has to be
    // re-snapped after a resize or the track lands mid-card.
    realign() {
      this.jumpToSlide(this.current);
    }

    jumpTo(left) {
      this.track.classList.add('is-jumping');
      this.track.scrollLeft = left;
      void this.track.offsetWidth;
      this.track.classList.remove('is-jumping');
    }

    jumpToSlide(index) {
      const slide = this.slides[index];
      if (!slide) return;
      this.jumpTo(slide.offsetLeft);
    }

    go(direction) {
      const total = this.slides.length;
      if (!total) return;

      let next = this.current + direction;
      if (!this.hasClones) {
        next = this.loop ? (next + total) % total : Math.max(0, Math.min(total - 1, next));
      } else {
        next = Math.max(0, Math.min(total - 1, next));
      }
      this.scrollToSlide(next);
    }

    scrollToSlide(index) {
      const slide = this.slides[index];
      if (!slide) return;
      this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }

    // Pick whichever copy of the requested real card is closest, so dots
    // travel the short way round instead of rewinding across the whole track.
    scrollToRealIndex(realIndex) {
      const total = this.slides.length;
      const from = this.current;
      let target = realIndex;
      let min = Infinity;

      for (let i = 0; i < total; i += 1) {
        if (i % this.realCount !== realIndex) continue;
        const distance = Math.abs(i - from);
        if (distance < min) {
          min = distance;
          target = i;
        }
      }
      this.scrollToSlide(target);
    }

    initDrag() {
      let startX = 0;
      let startScroll = 0;
      let distance = 0;

      // Touch scrolls natively via scroll-snap, only handle mouse and pen
      this.track.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'touch' || event.button !== 0) return;
        this.isDragging = true;
        distance = 0;
        startX = event.clientX;
        startScroll = this.track.scrollLeft;
        this.track.classList.add('is-dragging');
        this.track.setPointerCapture(event.pointerId);
      });

      this.track.addEventListener('pointermove', (event) => {
        if (!this.isDragging) return;
        const delta = event.clientX - startX;
        distance = Math.abs(delta);
        this.track.scrollLeft = startScroll - delta;
      });

      const release = (event) => {
        if (!this.isDragging) return;
        this.isDragging = false;
        this.track.classList.remove('is-dragging');
        if (this.track.hasPointerCapture?.(event.pointerId)) {
          this.track.releasePointerCapture(event.pointerId);
        }
        this.scrollToSlide(this.current);
      };

      this.track.addEventListener('pointerup', release);
      this.track.addEventListener('pointercancel', release);

      this.track.addEventListener(
        'click',
        (event) => {
          if (distance > 5) {
            event.preventDefault();
            event.stopPropagation();
          }
        },
        true
      );

      this.track.addEventListener('dragstart', (event) => event.preventDefault());
    }

    initAutoplay() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.autoplayInterval = Number(this.dataset.autoplayInterval || 5) * 1000;
      if (!this.autoplayInterval) return;

      // Filtered on pointer type: a tap fires pointerenter with no matching
      // pointerleave, which would kill autoplay permanently on touch devices.
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') this.stopAutoplay();
      });
      this.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') this.startAutoplay();
      });
      this.addEventListener('focusin', () => this.stopAutoplay());
      this.addEventListener('focusout', () => this.startAutoplay());

      // Pause while a finger is driving the track, resume once it lifts
      this.track.addEventListener('touchstart', () => this.stopAutoplay(), { passive: true });
      this.track.addEventListener('touchend', () => this.startAutoplay(), { passive: true });
      this.track.addEventListener('touchcancel', () => this.startAutoplay(), { passive: true });

      this.handleVisibility = () => {
        if (document.hidden) this.stopAutoplay();
        else this.startAutoplay();
      };
      document.addEventListener('visibilitychange', this.handleVisibility);

      // Do not run the timer while the carousel is off screen
      this.visibilityObserver = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) this.startAutoplay();
          else this.stopAutoplay();
        },
        { threshold: 0.2 }
      );
      this.visibilityObserver.observe(this);
    }

    startAutoplay() {
      if (!this.autoplayInterval || this.autoplayTimer) return;
      this.autoplayTimer = setInterval(() => {
        if (this.slides.length < 2) return;
        // With more than one card in view the last index is never reachable,
        // so the end of the run is the end of the scrollable range.
        if (!this.hasClones && !this.loop && this.track.scrollLeft >= this.maxScroll - 1) {
          this.stopAutoplay();
          return;
        }
        this.go(1);
      }, this.autoplayInterval);
    }

    stopAutoplay() {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }

    buildDots() {
      if (!this.dotsEl) return;
      this.dotsEl.innerHTML = '';
      for (let i = 0; i < this.realCount; i += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'carousel__dot';
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        dot.addEventListener('click', () => this.scrollToRealIndex(i));
        this.dotsEl.appendChild(dot);
      }
    }

    sync() {
      const index = this.current;
      const realIndex = this.realCount ? index % this.realCount : 0;

      if (!this.loop) {
        const max = this.maxScroll;
        if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 1;
        if (this.nextBtn) this.nextBtn.disabled = max <= 1 || this.track.scrollLeft >= max - 1;
      }

      this.dotsEl?.querySelectorAll('.carousel__dot').forEach((dot, i) => {
        dot.setAttribute('aria-current', String(i === realIndex));
      });
    }

    debounce(fn, wait) {
      let timer;
      return () => {
        clearTimeout(timer);
        timer = setTimeout(fn, wait);
      };
    }
  }

  if (!customElements.get('carousel-block')) {
    customElements.define('carousel-block', CarouselBlock);
  }
  } catch(e) { console.error(e); }
})();

})();
